import Vue from 'vue';
import VeeValidate from 'vee-validate';
import messagesEs from 'vee-validate/dist/locale/es.js';
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    userNombre: {
      required: 'Debes aceptar las política de privacidad',
    },
    password: {
      required: 'Debes introducir una contraseña válida',
    },
    repeatPassword: {
      required: 'Las contraseñas deben coincidir', //'Debes repetir la contraseña',
    },
    name: {
      required: 'El campo nombre es obligatorio',
    },
    surnames: {
      required: 'El campo apellidos es obligatorio',
    },
    email: {
      required: 'El campo email es obligatorio',
    },
    phone: {
      required: 'El campo teléfono es obligatorio',
    },
    phone_prefix: {
      required: 'El campo prefijo de teléfono es obligatorio',
    },
    address: {
      required: 'El campo dirección es obligatorio',
    },
    town: {
      required: 'El campo ciudad / municipio es obligatorio',
    },
    province: {
      required: 'El campo provincia es obligatorio',
    },
    postal_code: {
      required: 'El campo código postal es obligatorio',
    },
    description: {
      required: 'El campo descripción es obligatorio',
    },
    latitude: {
      required: 'El campo latitud es obligatorio',
    },
    longitude: {
      required: 'El campo longitud es obligatorio',
    },
    description: {
      required: 'El campo descripción es obligatorio',
    },
    max_daily_amount: {
      required: 'El campo importe máximo por día es obligatorio',
    },
    price_per_minute_charger: {
      required: 'El campo precio por minuto cargador es obligatorio',
    },
    price_per_minute: {
      required: 'El campo precio por minuto es obligatorio',
    },
    dni: {
      required: 'El campo dni es obligatorio',
    },
    end_datetime: {
      required: 'El campo fecha de inicio es obligatorio',
    },
    start_datetime: {
      required: 'El campo fecha de inicio es obligatorio',
    },
    billing_name: {
      required: 'El campo titular es obligatorio',
    },
    billing_identification: {
      required: 'El campo identificación es obligatorio',
    },
    billing_town: {
      required: 'El campo municipio es obligatorio',
    },
    billing_province: {
      required: 'El campo provincia es obligatorio',
    },
    billing_address: {
      required: 'El campo dirección es obligatorio',
    },
    billing_company: {
      required: 'El campo empresa es obligatorio',
    },
  },
};

Vue.use(VeeValidate, {
  locale: 'es',
  dictionary: {
    es: messagesEs,
  },
  fieldsBagName: 'veeFields',
});

Validator.localize('es', dict);

// const extendOptions = { hasTarget: true };

Validator.extend('samePassword', {
  getMessage: (field) => 'Las contraseñas deben coincidir',
  validate: (value, obj) => obj && obj[0] == value,
});

Validator.extend('email', {
  getMessage: field => 'Email introducido no es válido',
  validate: (value, obj) => {
    if (!obj) return false;

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value);
  }
});

Validator.extend('formatPassword', {
  getMessage: (field) =>
    'Debes introducir una contraseña válida. Introduce mínimo 8 caracteres, una mayúscula, una minúscula y un número.',
  // La contraseña debe tener mínimo 8 caracteres  y debe contener mayúsculas, minúsculas y números
  validate: (value) =>
    value && /^(?=.{8,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])/.test(value),
  // /^(?=.{8,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?\W)/   // con carácter especial:
});

Validator.extend('telefono', {
  getMessage: (field) => 'Debes introducir un número de teléfono válido.',
  validate: (value) => value && /^[9|8|7|6][0-9]{8}$/.test(value),
});


Validator.extend('importe-test', {
  getMessage: (field) => 'Debes introducir un importe válido.',
  validate: (value) => value & /^[+-]?(\d*\.)?\d+$/.test(value)
});

Validator.extend('importe', {
  getMessage: (field) => 'Debes introducir un importe válido. Dos decimales',
  validate: (value) => value && /^\d{1,3}(\.?\d{3})*(,\d{1,2})?$/.test(value),

  /// ^\d{1,3}(\.?\d{3})*(,\d{1,2})?$
  // \d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})

  // && /^\d+(?:\.\d{1,2})?$/.test(value),
});

Validator.extend('postal_code', {
  getMessage: (field) => 'Debes introducir un código postal válido.',
  validate: (value) => value && /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/.test(value)
});

Validator.extend('identificacion', {
  getMessage: (field, tipo_identificacion) => `${tipo_identificacion} no tiene el formato adecuado.`,
  validate: (value, tipo_identificacion) => {

    if (tipo_identificacion == "DNI" || tipo_identificacion == "NIE" || tipo_identificacion == "NIF" ) {

      let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
      let nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
      let nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
      let str = value.toString().toUpperCase();

      if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

      let nie = str
        .replace(/^[X]/, '0')
        .replace(/^[Y]/, '1')
        .replace(/^[Z]/, '2');

      let letter = str.substr(-1);
      let charIndex = parseInt(nie.substr(0, 8)) % 23;

      if (validChars.charAt(charIndex) === letter) {
        return true;
      }

      return false;

    } else if (tipo_identificacion === "Pasaporte") {
      return /^[a-z]{3}[0-9]{6}[a-z]?$/i.test(value);
    }
    else if (tipo_identificacion.includes("CIF")) {

      let cif = value;

      if (!cif || cif.length !== 9) {
        return false;
      }

      let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
      let digits = cif.substr(1, cif.length - 2);
      let letter = cif.substr(0, 1);
      let control = cif.substr(cif.length - 1);
      let sum = 0;
      let i;
      let digit;

      if (!letter.match(/[A-Z]/)) {
        return false;
      }

      for (let i = 0; i < digits.length; ++i) {
        let digit = parseInt(digits[i]);

        if (isNaN(digit)) {
          return false;
        }

        if (i % 2 === 0) {
          digit *= 2;
          if (digit > 9) {
            digit = parseInt(digit / 10) + (digit % 10);
          }

          sum += digit;
        } else {
          sum += digit;
        }
      }

      sum %= 10;
      if (sum !== 0) {
        digit = 10 - sum;
      } else {
        digit = sum;
      }

      if (letter.match(/[ABEH]/)) {
        return String(digit) === control;
      }
      if (letter.match(/[NPQRSW]/)) {
        return letters[digit] === control;
      }

      return String(digit) === control || letters[digit] === control;
    }
    else {
      return (value === null || value.match(/^ *$/) !== null)
    }
  }
});

Validator.extend('cif', {
  getMessage: field => 'El ' + field + ' no tiene el formato correcto.',
  validate: (value) => {
    let cif = value;

    if (!cif || cif.length !== 9) {
      return false;
    }

    let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    let digits = cif.substr(1, cif.length - 2);
    let letter = cif.substr(0, 1);
    let control = cif.substr(cif.length - 1);
    let sum = 0;
    let i;
    let digit;

    if (!letter.match(/[A-Z]/)) {
      return false;
    }

    for (let i = 0; i < digits.length; ++i) {
      let digit = parseInt(digits[i]);

      if (isNaN(digit)) {
        return false;
      }

      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit = parseInt(digit / 10) + (digit % 10);
        }

        sum += digit;
      } else {
        sum += digit;
      }
    }

    sum %= 10;
    if (sum !== 0) {
      digit = 10 - sum;
    } else {
      digit = sum;
    }

    if (letter.match(/[ABEH]/)) {
      return String(digit) === control;
    }
    if (letter.match(/[NPQRSW]/)) {
      return letters[digit] === control;
    }

    return String(digit) === control || letters[digit] === control;
  }
});


